/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_HistoryInputs */

const en_admin_ai_chat_history = /** @type {(inputs: Admin_Ai_Chat_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat history`)
};

const de_admin_ai_chat_history = /** @type {(inputs: Admin_Ai_Chat_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatverlauf`)
};

const es_admin_ai_chat_history = /** @type {(inputs: Admin_Ai_Chat_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de chats`)
};

const fr_admin_ai_chat_history = /** @type {(inputs: Admin_Ai_Chat_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique des chats`)
};

const nl_admin_ai_chat_history = /** @type {(inputs: Admin_Ai_Chat_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatgeschiedenis`)
};

/** @type {(inputs: Admin_Ai_Chat_HistoryInputs) => LocalizedString} */
const it_admin_ai_chat_history = en_admin_ai_chat_history;

/** @type {(inputs: Admin_Ai_Chat_HistoryInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_history = en_admin_ai_chat_history;

/** @type {(inputs: Admin_Ai_Chat_HistoryInputs) => LocalizedString} */
const pl_admin_ai_chat_history = en_admin_ai_chat_history;

/** @type {(inputs: Admin_Ai_Chat_HistoryInputs) => LocalizedString} */
const hu_admin_ai_chat_history = en_admin_ai_chat_history;

/** @type {(inputs: Admin_Ai_Chat_HistoryInputs) => LocalizedString} */
const ro_admin_ai_chat_history = en_admin_ai_chat_history;

/**
* | output |
* | --- |
* | "Chat history" |
*
* @param {Admin_Ai_Chat_HistoryInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_history = /** @type {((inputs?: Admin_Ai_Chat_HistoryInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_HistoryInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_history(inputs)
	if (locale === "de") return de_admin_ai_chat_history(inputs)
	if (locale === "es") return es_admin_ai_chat_history(inputs)
	if (locale === "fr") return fr_admin_ai_chat_history(inputs)
	if (locale === "nl") return nl_admin_ai_chat_history(inputs)
	if (locale === "it") return it_admin_ai_chat_history(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_history(inputs)
	if (locale === "pl") return pl_admin_ai_chat_history(inputs)
	if (locale === "hu") return hu_admin_ai_chat_history(inputs)
	return ro_admin_ai_chat_history(inputs)
});
export { admin_ai_chat_history as "admin.ai_chat.history" }